import React from 'react';
import Card from '@material-ui/core/Card';
import { withStyles } from '@material-ui/core/styles';

const styles = {
    card: {
        float: 'left',
        margin: '0px 20px 0 0px',
        zIndex: 100,
        borderRadius: 3,
        boxShadow:"none",
        border:0
    },
    icon: {
        display: 'block',
        float: 'left',
        width: 54,
        height: 54,
        padding: 0,
        color: '#000',
        fontSize: '30px'
    },
};

const CardIcon = ({ Icon, name, classes }) => (
    <Card className={classes.card}>
        <Icon className={classes.icon} />
    </Card>
);

export default withStyles(styles)(CardIcon);



// WEBPACK FOOTER //
// ./src/components/dashboard/cards/CardIcon.js